
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const Home = lazy(() => import('../pages/home/page'));
const Reviews = lazy(() => import('../pages/reviews/page'));
const Submit = lazy(() => import('../pages/submit/page'));
const Admin = lazy(() => import('../pages/admin/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const ReviewDetail = lazy(() => import('../pages/review-detail/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/reviews',
    element: <Reviews />,
  },
  {
    path: '/reviews/:id',
    element: <ReviewDetail />,
  },
  {
    path: '/submit',
    element: <Submit />,
  },
  {
    path: '/admin',
    element: <Admin />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
